import { FormControl, Grid } from "@mui/material";
import { DropzoneArea } from "mui-file-dropzone";
import { get } from "lodash";
import DictationControl from "../dictation/DictationControl";
import NotesInput from "../form/NotesInput";
import CustomDatePicker from "../form/CustomDatePicker/CustomDatePicker";
import { MAX_ATTACHMENT_FILE_BYTES } from "../../utils/attachmentUploadLimits";
import { attachmentPreviewIcon } from "./attachmentPreviewIcon";
import AttachmentUploadSizeNotice from "./AttachmentUploadSizeNotice";

const PaperEncounterInput = ({
  actualPeriod,
  setActualPeriod,
  chiefComplaint,
  setChiefComplaint,
  setSaved,
  subject,
  setUploadedFiles,
  uploadedFiles,
}) => (
  <Grid container spacing={3} xs={12} md={12}>
    <Grid item xs={12} md={6}>
      <CustomDatePicker
        maxDateTime={new Date()}
        label="Encounter Date"
        value={actualPeriod.start}
        onChange={(date) => {
          setActualPeriod({
            ...actualPeriod,
            start: date,
          });
        }}
        required
      />
    </Grid>
    <Grid item xs={12}>
      <FormControl variant="outlined" fullWidth>
        <DictationControl
          value={get(chiefComplaint, "summary") ?? ""}
          onTextChange={(value) => {
            setChiefComplaint({
              ...chiefComplaint,
              summary: value,
            });
            setSaved(false);
          }}
          id="encounter-chief-complaint-summary"
          label="Chief Complaint"
          placeholder="Summary of the complaint"
          required
          disabled={!subject?.identifier}
          minRows={1}
          maxRows={2}
          style={{ width: "100%" }}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12}>
      <FormControl variant="outlined" fullWidth>
        <NotesInput
          value={chiefComplaint?.note}
          label="Encounter Notes"
          onChange={(notes) => {
            setChiefComplaint({
              ...chiefComplaint,
              note: notes,
            });
            setSaved(false);
          }}
          placeholderText="Please add as much information as possible about the paper encounter being uploaded."
          disabled={!subject?.identifier}
          minRows={3}
          maxNotes={1}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12}>
      <DropzoneArea
        onChange={(loadedFiles) => {
          setUploadedFiles(loadedFiles);

          // Component calls onChange when mounting so this
          // simply protects saved against calls on mount
          if (loadedFiles.length !== uploadedFiles.length) {
            setSaved(false);
          }
        }}
        maxFileSize={MAX_ATTACHMENT_FILE_BYTES}
        getPreviewIcon={attachmentPreviewIcon}
        acceptedFiles={[
          "image/*",
          "video/*",
          "audio/*",
          "text/plain",
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          "application/dicom",
          ".dcm",
        ]}
      />
      <AttachmentUploadSizeNotice files={uploadedFiles ?? []} />
    </Grid>
  </Grid>
);

export default PaperEncounterInput;
